<template>
  <div class="user-task-finishing" v-if="viewType === 'finishing'">
    <div class="dialog">
      <div class="content">
        <div class="figure"></div>
        <div class="text-1" @click="toSupportPage">恭喜！您已经完成了所有新人任务！
</div>
        <!-- <div class="text-2">请点击下列按钮升级至<span class="h">1天动画个人会员（体验版）</span></div> -->
        <div class="btn-wrapper">
          <div class="btn" @click="getVip">
            <!-- 领取会员 -->
            完成教学
          </div>
        </div>
      </div>
      <div class="footer">
        路径动画、转场效果、AI配音、智能字幕，更多高阶功能，点此<span class="h" @click="toSupportPage">了解更多</span>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
  computed: {
    ...mapGetters({
      viewType: 'userTask/viewType',
      step: 'userTask/step'
    }),
  },
  methods: {
    async getVip () {
      sensors.track('templateUserGuide', {});
      // const resp = await this.$http.post('/api/user/info/getTaskVip');
      // const code = resp.data.code;
      // if (code !== 200) {
      //   this.$message({
      //     message: '领取体验会员失败',
      //     type: "error",
      //   });
      //   return;
      // }
      this.$store.commit('userTask/setViewType', 'leave');
      this.$bus.emit("upDataUserMsg_vue");
      // this.$message({
      //   type: 'success',
      //   message: '会员已成功领取，祝创作愉快！'
      // });
    },
    toSupportPage () {
      // const link = document.createElement('a');
      // link.target = '_blank';
      // link.src = 'https://support.laihua.com/';
      // link.click();
      window.open('https://support.laihua.com/');
    }
  }
}
</script>
<style scoped lang="scss">
.user-task-finishing {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(#000000, .6);
  z-index: 2147483647;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog {
  background-color: #fff;
}
.content {
  width: 560px;
  height: 394px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 43px;
}
.figure {
  width: 202px;
  height: 164px;
  margin-bottom: 37px;
  background-image: url(./images/finishing.png);
  background-size: 100% 100%;
}
.text-1 {
  margin-bottom: 10px;
}
.text-2 {
  .h {
    color: #5778FB;
    font-weight: bold;
  }
  margin-bottom: 30px;
}
.btn-wrapper {
  margin-bottom: 36px;
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 40px;
    background: #5778FB;
    opacity: 1;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
  }
}
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 560px;
  height: 40px;
  background: #F8F8FB;
  opacity: 1;
  border-radius: 4px;
  .h {
    color: #5778FB;
    border-bottom: solid 1px #5778FB;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userTask/finishingModal.vue